export const sectionContent = {
  hero: {
    greeting: "Hey, I'm",
    metaYear: "Portfolio / 2026",
    description: "Software engineer with 2+ years of experience shipping Gen AI products and building AI applications — currently shipping Go + Next.js at Bluecopa.",
    cta: {
      primary: "View My Work",
      secondary: "Get In Touch",
      bookMeeting: "Book a Call"
    },
    downloadResume: "Download Resume",
    currentlyLabel: "Currently",
    experienceLabel: "Experience"
  },

  about: {
    title: "About Me",
    subtitle: "Software engineer focused on shipping Gen AI products",
    content: [
      "I'm a Software Development Engineer with 2+ years of experience shipping Gen AI products and building scalable AI applications. Currently at Bluecopa, shipping Go and Next.js features to production.",
      "I've designed Go REST APIs with 40% p95 latency reduction, deployed microservices on GCP/Kubernetes with 99.9% uptime, and built LLM-powered automation pipelines that process tens of thousands of events daily.",
      "Open to Backend, Full Stack, SRE/DevOps, and Go roles — remote (India), US, or Gulf region. 300+ LeetCode problems solved; promoted at Cognizant within 6 months."
    ]
  },

  skills: {
    title: "Skills & Technologies",
    subtitle: "Production stack for shipping Gen AI products, AI applications, and scalable backend systems"
  },

  codingActivity: {
    title: "Coding Activity",
    githubStreak: "GitHub Streak",
    leetcodeStats: "LeetCode Stats",
    githubStats: "GitHub Stats",
    topLanguages: "Most Used Languages",
    contributions: "GitHub Contributions"
  },

  certifications: {
    title: "Certifications & Achievements",
    subtitle: "Continuous learning and recognition of expertise",
    professionalCerts: "Professional Certifications",
    keyAchievements: "Key Achievements"
  },

  portfolio: {
    title: "Featured Projects",
    subtitle: "Full-stack products, mobile apps, and UI/UX-led frontend work across real estate, e-commerce, and AI",
    viewProject: "View Project",
    viewCode: "View Code",
    viewDemo: "Live Demo"
  },

  contact: {
    title: "Let's Connect",
    subtitle: "Open to Backend, Full Stack, SRE/DevOps, and Go roles. Remote (India), US, or Gulf region.",
    contactDetails: "Contact Details",
    contactDetailsSubtitle: "Choose your preferred way to reach out",
    sendMessage: "Message on WhatsApp",
    sendMessageSubtitle: "Compose a message — opens WhatsApp with your text pre-filled",
    labels: {
      name: "Name",
      email: "Email",
      message: "Message"
    },
    placeholders: {
      name: "Your name",
      email: "you@example.com",
      message: "Tell me about the role, project, or how we can collaborate..."
    },
    whatsapp: {
      send: "Send via WhatsApp",
      sent: "Message Sent!",
      preview: "Preview",
      greeting: "Hello Vishal Panwar..!!"
    },
    footer: "Or reach me at"
  },

  footer: {
    tagline: "Software Development Engineer | Gen AI Products · Backend · Cloud",
    quickLinks: "Quick Links",
    connectWithMe: "Connect With Me",
    copyright: "© 2026 Vishal Panwar. All rights reserved.",
    links: {
      leetcode: "LeetCode",
      sourceCode: "Source Code"
    }
  },

  navigation: {
    items: ["About", "Skills", "Certifications", "Portfolio"],
    contact: "Contact"
  },

  meta: {
    siteUrl: "https://vishalpanwar.in",
    title: "Vishal Panwar | Software Development Engineer | Gen AI Products · Backend",
    description: "Vishal Panwar — Software Development Engineer shipping Gen AI products and AI applications with Go, Next.js, and GCP. 2+ years at Bluecopa, Discovr.ai, Implere Tech, and Cognizant.",
    keywords: "Vishal Panwar, Gen AI, AI Applications, Software Development Engineer, Backend Engineer, Go Developer, Golang, Next.js, GCP, Kubernetes, LLM, AI Engineer, Portfolio, Hyderabad, Remote",
    ogTitle: "Vishal Panwar | Gen AI · Backend · Cloud Engineer",
    ogDescription: "Building and shipping Gen AI products and AI applications with Go, Next.js, and GCP. 2+ years shipping production systems.",
    ogImage: "https://vishalpanwar.in/og-image.png",
    twitterCard: "summary_large_image"
  },

  loadingScreen: {
    progressLabel: "%"
  },

  availability: {
    statusText: "Open to opportunities",
    bookMeeting: "Book a Meeting"
  }
}
